import config from 'config';
import IMAGEM from '../imagem';
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';
import { formatDate } from 'components/formatos';

const Contemplados = ({nome_sorteado, nome_estabelecimento, limages, datasorteio}) => {
  const llimages = limages && Array.isArray(limages) ? [...limages] : [];

  return (
    <div className="ganhador-card">
      <div className="ganhador-image-section">
        <Carousel controls={false} indicators={false} interval={3000} fade>
          {llimages.length > 0 ? (
            llimages.map((i, index) => (
              <Carousel.Item key={`cont${index}`}>
                <div className="ganhador-img-container">                
                  <IMAGEM 
                    participantes={true}
                    src={`${config.BASEIMG}${i.url_foto}`} 
                    className="ganhador-img"
                    alt={nome_sorteado} 
                  />
                </div>
              </Carousel.Item>
            ))
          ) : (
            <Carousel.Item>
              <div className="ganhador-img-container empty">
                <i className="fas fa-user-circle"></i>
              </div>
            </Carousel.Item>
          )}
        </Carousel>
        <div className="ganhador-badge">
          <i className="fas fa-trophy me-1"></i> Ganhador
        </div>
      </div>
      
      <div className="ganhador-info">
        <h5 className="ganhador-name">{nome_sorteado}</h5>
        <div className="ganhador-details">
          <div className="detail-item">
            <i className="fas fa-store"></i>
            <span>{nome_estabelecimento}</span>
          </div>
          <div className="detail-item">
            <i className="fas fa-calendar-alt"></i>
            <span>{formatDate(datasorteio)}</span>
          </div>
        </div>
      </div>
      
      <div className="ganhador-footer">
        <button className="btn-ganhador-detalhe">
          Ver prêmio <i className="fas fa-chevron-right ms-1"></i>
        </button>
      </div>
    </div>
  );
};

export default Contemplados;